<h2 mat-dialog-title>{{'Parametres' | translate}}</h2>
<mat-dialog-content>
    <!--
    <mat-tab-group *ngIf="HTML_Param" style="background-color: whitesmoke; border: solid 1px black;">
        <mat-tab label="{{'Décorticage' | translate}}">
        </mat-tab>
    </mat-tab-group>
    -->
  <mat-list style="background-color: whitesmoke; border: solid 1px black;">

    <mat-list-item>
        <div class="col-option">
            <div><mat-checkbox [(ngModel)]="HTML_Param.ShowMemberColumn">{{'Afficher la colonne des éléments' | translate}}</mat-checkbox></div>
        </div>
    </mat-list-item>

    <mat-list-item>
        <div class="col-option">
            <div><mat-checkbox [(ngModel)]="HTML_Param.InputDistribution">{{'Saisie de répartitions' | translate}}</mat-checkbox></div>
        </div>
    </mat-list-item>

    <mat-list-item>
      <div class="col-option">
        <div><mat-checkbox [(ngModel)]="HTML_Param.AnalysisHideComment">{{'Masquer les commentaires' | translate}}</mat-checkbox></div>
      </div>
    </mat-list-item>

    <mat-list-item>
        <mat-radio-group style="margin: 0 10px;" [(ngModel)]="HTML_Param.ImageType">
            <mat-radio-button style="margin: 0 20px;" value="Simple">{{'Simple (le plus rapide)' | translate}}</mat-radio-button>
            <mat-radio-button style="margin: 0 20px;" value="Full">{{'Complet avec mesure (le plus lent)' | translate}}</mat-radio-button>
        </mat-radio-group>
    </mat-list-item>

    <mat-divider></mat-divider>

    <mat-list-item><label>{{'Forme saisie :' | translate}}</label></mat-list-item>

    <mat-list-item>
        <mat-radio-group style="margin: 0 10px;" [(ngModel)]="HTML_Param.AnalysisInputType">
            <mat-radio-button style="margin: 0 20px;" value="Classical">{{'Classique' | translate}}</mat-radio-button>
            <mat-radio-button style="margin: 0 20px;" value="BS 4466 / 8666">{{'BS 4466 / 8666' | translate}}</mat-radio-button>
        </mat-radio-group>
    </mat-list-item>

    <mat-divider></mat-divider>

    <mat-list-item><label>{{'Aide saisie' | translate}}</label></mat-list-item>

    <mat-list-item>
        <div class="col-option" style="margin: 0 30px;">
            <mat-checkbox [(ngModel)]="HTML_Param.InputPreviousShape">{{'Forme précédente' | translate}}</mat-checkbox>
            <mat-checkbox [(ngModel)]="HTML_Param.InputPreviousDiamter">{{'Diamètre précédent' | translate}}</mat-checkbox>
            <mat-checkbox [(ngModel)]="HTML_Param.InputPreviousGrade">{{'Nuance précédente' | translate}}</mat-checkbox>
            <mat-checkbox [(ngModel)]="HTML_Param.InputPreviousQty">{{'Quantitée précédente' | translate}}</mat-checkbox>
            <mat-checkbox [(ngModel)]="HTML_Param.InputPreviousMeasure">{{'Cotes précédentes' | translate}}</mat-checkbox>
        </div>
    </mat-list-item>

    <mat-list-item><label>{{'Repère' | translate}}</label></mat-list-item>

    <mat-list-item>
        <mat-radio-group style="margin: 0 10px;" [(ngModel)]="HTML_Param.InputPreviousBM">
            <mat-radio-button style="margin:  0 20px;" value="none">{{'Manuelle' | translate}}</mat-radio-button>
            <mat-radio-button style="margin:  0 20px;" value="number">{{'Numérique auto.' | translate}}</mat-radio-button>
            <mat-radio-button style="margin:  0 20px;" value="letter">{{'Alphabétique auto.' | translate}}</mat-radio-button>
        </mat-radio-group>
    </mat-list-item>
  </mat-list>

</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-raised-button (click)="onDialogBtnClick('save')">{{'Enregistrer' | translate}}</button>
  <button mat-raised-button (click)="onDialogBtnClick('close')">{{'Fermer' | translate}}</button>
</div>
